import { pathOr } from 'ramda';

import { IState } from '../store';

export const getDynamicCalltrackingSiteBlockId = (state: IState) => {
  return pathOr<number | null>(null, ['offerData', 'newbuildingDynamicCalltracking', 'siteBlockId'], state);
};
